var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgNotificationPlaceholder = function SvgImgNotificationPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.702 24.849C36.757 21.474 33.668 19 30 19h-.013a7.994 7.994 0 0 0-7.257 4.649h.01a8.003 8.003 0 0 0-.741 3.37c0 4.43 3.583 8.023 8.001 8.023 0 0-1.268 4.583-4.04 6.958 0 0 10.086-3.887 11.873-13.203.099-.518.166-1.251.166-1.777 0-.752-.105-1.48-.298-2.171Z",
    fill: "#2CCCD3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 3.5,
    stroke: "#242526",
    strokeOpacity: 0.1
  })));
};
export default SvgImgNotificationPlaceholder;